import { render, staticRenderFns } from "./DeviceRecord.vue?vue&type=template&id=52b1b7be&"
import script from "./DeviceRecord.vue?vue&type=script&lang=js&"
export * from "./DeviceRecord.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports